import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import React from 'react'

import styles from './Dialog.module.sass'

const ConfirmDialog = (props) => {
	const { className, data, resolve, dismiss } = props
	const { i18n } = useGlobal()
	return (
		<div className={`${styles['root'] || ''} ${className || ''}`}>
			<div>
				<small className={styles['dialog-title']}>
					{data?.label || i18n`Are you sure?`}
				</small>
			</div>
			<HStack
				className={styles['actions-container']}
				gap='xsmall'
				justify='flex-end'
			>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`No`}</strong>
					</small>
				</ActionButton>
				<ActionButton type='button' primary onClick={resolve}>
					<small>
						<strong>{i18n`Yes`}</strong>
					</small>
				</ActionButton>
			</HStack>
		</div>
	)
}

export default ConfirmDialog
